__turbopack_context__.v({
  "digikalaGroupImage": "psFh-a_digikalaGroupImage",
  "heading2": "psFh-a_heading2",
  "heading3": "psFh-a_heading3",
  "imageWrapper": "psFh-a_imageWrapper",
  "pageTitle": "psFh-a_pageTitle",
  "paragraph": "psFh-a_paragraph",
});
